import styled from 'styled-components/macro'

export const FeedSC = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`
